import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJswConfigurationRoute: InvariantJiraRoute = {
	name: 'products-jsw-configuration',
	path: '/jira/settings/products/jira-software-configuration',
	exact: true,
};
